import React from "react"
import { Card, CardContent, Typography, makeStyles } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import TableView from "../../common/TableView/TableView"

const useStyles = makeStyles((theme) => ({
	card: {
		height: "460px",
	},
	cardContent: {
		padding: "24px",
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: theme.typography.subTitle1.fontWeight,
		paddingBottom: "16px",
	},
}))

const OverallCountTable = () => {
	const [t] = useTranslation("global")
	const caseDetails = useSelector((state) => state.bifrostCaseDetails.caseDetails)
	const isPageLoading = useSelector((state) => state.bifrostCaseDetails.isLoading)
	const classes = useStyles()

	const getRows = () => {
		return [
			{
				id: "supported_filegroup",
				fileGroup: t("bifrost.table_headers.supported"),
				fileCount: caseDetails?.files_summary?.supported_file?.count,
				fileSize: caseDetails?.files_summary?.supported_file?.size,
			},
			{
				id: "supported_unique_filegroup",
				fileGroup: t("bifrost.table_headers.supportedUnique"),
				fileCount: caseDetails?.files_summary?.supported_unique_files?.count,
				fileSize: caseDetails?.files_summary?.supported_file?.size,
			},
			{
				id: "unsupported_filegroup",
				fileGroup: t("bifrost.table_headers.unsupported"),
				fileCount: caseDetails?.files_summary?.total_files?.count - caseDetails?.files_summary?.supported_file?.count,
				fileSize: "—", //**To do: update it when we get data from backend not getting unsupported data fat present
			},
			{
				id: "duplicate_total_filegroup",
				fileGroup: t("bifrost.table_headers.duplicateTotal"),
				fileCount: caseDetails?.files_summary?.duplicate_files?.count,
				fileSize: caseDetails?.files_summary?.duplicate_files?.size,
			},
		]
	}

	const getColumns = () => {
		return [
			{
				field: "fileGroup",
				headerName: t("bifrost.table_headers.fileGroup"),
				sortable: false,
				resizable: true,
				flex: 0.2,
				width: 170,
			},
			{
				field: "fileCount",
				headerName: t("bifrost.table_headers.fileCount"),
				sortable: false,
				resizable: true,
				flex: 0.2,
				width: 170,
			},
			{
				field: "fileSize",
				headerName: t("bifrost.table_headers.fileSize"),
				sortable: false,
				resizable: true,
				flex: 0.2,
				width: 170,
			},
		]
	}

	return (
		<Card className={classes.card}>
			<CardContent className={classes.cardContent}>
				<Typography variant="subtitle1" className={classes.title}>
					{t("bifrost.titles.overallCount")}
				</Typography>
				<TableView
					columns={getColumns()}
					rows={getRows()}
					isLoading={isPageLoading}
					pageInfo={{
						page: 1,
						pageSize: 4,
						rowsPerPageOptions: [],
						totalRowCount: 4,
						paginationMode: "server",
						handlePageChange: () => {},
						handlePageSizeChange: () => {},
					}}
					sortInfo={{
						sortingMode: "server",
						sortModel: [],
						onSortModelChange: () => {},
					}}
					footerInfo={{
						hideFooter: true,
						hideSelectionCount: true,
						hidePagination: true,
					}}
					checkboxSelection={false}
					topBarInfo={{
						show: false,
						rightSection: "",
					}}
				/>
			</CardContent>
		</Card>
	)
}

export default OverallCountTable
